import { Injectable, Inject } from '@angular/core';
import {
  QueryService as IQueryService,
  IQueryResult,
  IQueryGenericResult,
  IQueryGenericFacets,
} from '@relevance/core';

import { QueryServiceConfig, QUERY_CONFIG } from './query.config';

/**
 * This service exposes the query service as an Angular dependency.
 */
@Injectable()
export class QueryService<T extends IQueryResult = IQueryGenericResult, F extends object = IQueryGenericFacets>
  extends IQueryService<T, F> {

  constructor(
    @Inject(QUERY_CONFIG) config: QueryServiceConfig,
  ) {
    super(config.url);
  }

}
